import React, { useEffect, useState } from 'react'
import { withNamespaces } from 'react-i18next'
import logoPython from './images/python.svg'
import logoHeader from './images/congrats.svg'
import Card from './Card/Card'
import './Final.scss'
import { relatedProjects } from './relatedProjects'
import { Button } from '../Button/BTTButton'
import Input from '../Input/Input'
import Editor from '../Editor/Editor'
import { loadFromLocalStorage } from '../../../helpers/localStorage'
import {
  getUserCodeForStep,
  getRunnableCodeForStep,
  populateSelections,
} from '../../../utils/codeParsing'
import PropTypes from 'prop-types'

const Final = ({ codeTemplate, stepIndex, options, t }) => {
  const [finalStepTemplate, setFinalStepTemplate] = useState('')
  const [finalCode, setFinalCode] = useState('')

  const runCode = () => {
    const webComponent = document.querySelector('editor-wc')
    webComponent.rerunCode()
  }

  useEffect(() => {
    setFinalStepTemplate(
      getUserCodeForStep({
        template: codeTemplate,
        stepIndex,
        optionData: options,
      })
    )

    const runnableCode = getRunnableCodeForStep({
      template: codeTemplate,
      stepIndex: stepIndex,
    })

    setFinalCode(
      populateSelections(runnableCode, loadFromLocalStorage('selections'))
    )
  }, [])

  return (
    <div className="c-final-page">
      <section className="c-final-page__section c-final-page__section--completed">
        <header className="c-final-page__header">
          <img className="c-final-page__image" src={logoHeader} alt="logo" />
          <h2>{t('exercise.final.completed_activity')}</h2>
          <p className="c-final-page__text">{t('exercise.final.intro')}</p>
          <div className="c-final-page__buttons">
            <Button
              type="primary"
              text={'Run final code'}
              icon="play_arrow"
              iconPosition="right"
              textAlways={true}
              onClick={runCode}
            />
            <Button
              type="secondary"
              text={t('exercise.final.more_python_projects')}
              onClick={() =>
                document
                  .getElementById('more-python')
                  .scrollIntoView({ behavior: 'smooth' })
              }
            />
          </div>
        </header>
        <div className="c-final-page__code">
          <div className="c-final-page__code-input">
            <h3 className="c-final-page__code-heading rpf-squiggle-heading">
              {t('exercise.final.final_code')}
            </h3>
            <Input template={finalStepTemplate} />
          </div>
          <div className="c-final-page__code-output">
            <h3 className="c-final-page__code-heading rpf-squiggle-heading">
              {t('exercise.final.code_output')}
            </h3>
            <Editor codeToRun={finalCode} />
          </div>
        </div>
      </section>
      <section
        className="c-final-page__section c-final-page__python"
        id="more-python"
      >
        <div className="c-final-page__python-content">
          <h2>{t('exercise.final.more_python_projects')}</h2>
          <p className="c-final-page__python-text">
            {t('exercise.final.more_python_text')}
          </p>
          <Button
            type="primary"
            text={t('exercise.final.start_python_intro')}
            icon="open_in_new"
            iconPosition="right"
            href="https://projects.raspberrypi.org/en/pathways/python-intro"
            target="_blank"
            textAlways={true}
            onClick={() => {
              if (window.plausible) {
                window.plausible(`B2T Progress - Python Intro`)
              }
            }}
          />
        </div>
        <img className="c-final-page__python-image" src={logoPython} alt="" />
      </section>

      <section className="c-final-page__section c-final-page__html">
        <h2>{t('exercise.final.build_html_website')}</h2>
        <p className="c-final-page__html-text">
          {t('exercise.final.build_html_website_text')}
        </p>
        <div className="c-final-page__html-cards">
          {relatedProjects.map((project, index) => (
            <Card
              key={index}
              title={project.title}
              description={project.description}
              url={project.url}
              image={project.image}
              onClick={() => {
                if (window.plausible) {
                  window.plausible(`B2T Progress - ${project.title}`)
                }
              }}
            />
          ))}
        </div>
        <Button
          type="primary"
          outerClassName="c-final-page__html-button"
          text={t('exercise.final.start_web_intro')}
          icon="open_in_new"
          iconPosition="right"
          href="https://projects.raspberrypi.org/en/pathways/web-intro"
          target="_blank"
          textAlways={true}
          onClick={() => {
            if (window.plausible) {
              window.plausible(`B2T Progress - Web Intro`)
            }
          }}
        />
      </section>
    </div>
  )
}

Final.propTypes = {
  codeTemplate: PropTypes.string.isRequired,
  stepIndex: PropTypes.number.isRequired,
  options: PropTypes.object,
}

export default withNamespaces('translations')(Final)
